import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { BookMarked, MessageSquare, Brain, Mic2, ShieldCheck } from "lucide-react";
import Training from "../Training";
import { SectionHeader } from "./Capture";
import BrandMemory from "../nexus/BrandMemory";
import CustomerMemory from "../nexus/CustomerMemory";

const TABS = [
  { id: "brand",     label: "Brand Memory",    icon: BookMarked,    comp: BrandMemory,    hint: "Identity · positioning · tone · kit" },
  { id: "customer",  label: "Customer Memory", icon: MessageSquare, comp: CustomerMemory, hint: "Segments · pain · desires · objections" },
  { id: "memory",    label: "Knowledge",       icon: Brain,         comp: Training,       hint: "Trained context & FAQs" },
  { id: "voice",     label: "Tone & Voice",    icon: Mic2,          comp: Training,       hint: "How your Workforce sounds" },
  { id: "approvals", label: "Approvals",       icon: ShieldCheck,   comp: Training,       hint: "Teach the system on every reply" },
];

export default function Nexus() {
  const [params, setParams] = useSearchParams();
  const initial = params.get("tab") || "brand";
  const [tab, setTab] = useState(initial);
  const Active = TABS.find(t => t.id === tab)?.comp || BrandMemory;
  const meta = TABS.find(t => t.id === tab);

  return (
    <div data-testid="nexus-page">
      <SectionHeader title="Nexus" subtitle="The connected intelligence core powering your workspace" tabs={TABS} active={tab}
        onChange={(id) => { setTab(id); setParams({ tab: id }); }} hint={meta?.hint} />
      <Active />
    </div>
  );
}
